import { render } from "./Sorting.vue?vue&type=template&id=5733c995"
import script from "./Sorting.vue?vue&type=script&lang=ts"
export * from "./Sorting.vue?vue&type=script&lang=ts"
script.render = render

export default script